import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {LocaleChangeService} from './shared/services/locale/locale.change.service';
import {SecurityService} from './shared/services/security/security.service';
import {Locale} from './shared/types/localization/locale';

@Component({
  selector: 'wsd-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  direction: string;

  private defaultLocaleSubscription: Subscription;

  private localeSubscription: Subscription;

  constructor(private translate: TranslateService,
              private localeChangeService: LocaleChangeService,
              private securityService: SecurityService) {
    this.translate.setDefaultLang('en_GB');
  }

  ngOnInit() {
    this.defaultLocaleSubscription = this.securityService.getCurrentLocale().subscribe(
      (locale: Locale) => {
        this.translate.setDefaultLang(locale.code);
        this.setDirection(locale.code);
      }
    );
    this.localeSubscription = this.localeChangeService.messageSent$.subscribe(
      (locale: Locale) => {
        this.translate.setDefaultLang(locale.code);
        this.setDirection(locale.code);
        this.direction = locale.code === 'ar_AE' ? 'rtl' : 'ltr';
        this.refresh();
      }
    );
  }

  ngOnDestroy() {
    this.defaultLocaleSubscription.unsubscribe();
    this.localeSubscription.unsubscribe();
  }

  refresh() {
    window.location.reload();
  }

  private setDirection(code) {
    this.direction = code === 'ar_AE' ? 'rtl' : 'ltr';
  }
}
